"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fielderror_1 = require("./fielderror");
/**Un checkbox de un input simple */
class SimpleCheckbox extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleChange = (event) => {
            if (this.props.onChange)
                this.props.onChange(event.currentTarget.checked);
        };
    }
    render() {
        return (React.createElement("input", { type: "checkbox", checked: this.props.value || false, disabled: this.props.readonly, onChange: this.handleChange }));
    }
}
/**Un checkbox. Si no se establece un label el checkbox sera solamente el input, si se
 * establece un label el checkbox sera el checkbox estilizado para bootstrap
 */
class Checkbox extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "checkbox" },
            React.createElement("label", null,
                React.createElement(SimpleCheckbox, { value: this.props.value, readonly: this.props.readonly, onChange: this.props.onChange }),
                React.createElement("span", null,
                    this.props.label,
                    React.createElement(fielderror_1.FieldErrorView, { error: this.props.error })))));
    }
}
exports.Checkbox = Checkbox;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/checkbox.js
// module id = 2206
// module chunks = 0